import { StyleSheet } from "react-native";
export default StyleSheet.create({
  tabbarView: {
    backgroundColor: "transparent",
    flexDirection: "row"
  },
  iconView: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center"
  },
  hidden: {
    height: 0
  },
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    height: 500
  },
  welcome: {
    fontSize: 20,
    textAlign: "center",
    margin: 10
  },
  instructions: {
    textAlign: "center",
    marginBottom: 5
  }
});